"use strict";

exports.__esModule = true;
exports.AdvancedTimelineValueWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _DeviceProperty = require("../DeviceProperty");
var _AdvancedTimelineValueElement = require("./AdvancedTimelineValueElement");
var _AdvancedTimelineValueFields = require("./AdvancedTimelineValueFields");
var _TimelineValueHeader = require("./TimelineValueHeader");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedTimelineValueWidget = exports.AdvancedTimelineValueWidget = {
  name: "AdvancedTimelineValue",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedTimelineValueWidget.label",
    defaultMessage: "Advanced Timeline Value"
  }),
  icon: "trending-up",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AdvancedTimelineValue",
      props: Object.assign({
        width: 256,
        height: 64,
        timeline: "",
        dimensions: [],
        backgroundColorValueTuples: []
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "timeline"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _AdvancedTimelineValueElement.AdvancedTimelineValueElement,
    Fields: _AdvancedTimelineValueFields.AdvancedTimelineValueFields,
    Thumbnail: _DeviceProperty.DevicePropertyThumbnail,
    Header: _TimelineValueHeader.AdvancedTimelineValueHeader
  }
};